import React, { useState, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import axios from "axios";
import { useDropzone } from "react-dropzone";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const App = () => {
  const [numPages, setNumPages] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [splitType, setSplitType] = useState("vertical");
  const [splitPercentage, setSplitPercentage] = useState(50);
  const [splitDirection, setSplitDirection] = useState("left");
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState(null);
  const [splitLineVisible, setSplitLineVisible] = useState(false);

  const containerRef = useRef(null);
  const doorRef = useRef(null);
  const handleRef = useRef(null); // Reference to the draggable handle

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onCanvasMouseDown = (event) => {
    const containerRect = containerRef.current.getBoundingClientRect();
    const x = event.clientX - containerRect.left;
    const y = event.clientY - containerRect.top;

    setDragStart({ x, y });
    setIsDragging(true);
  };

  const onCanvasMouseMove = (event) => {
    if (isDragging) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const x = event.clientX - containerRect.left;
      const y = event.clientY - containerRect.top;

      if (dragStart) {
        let splitPercentageValue;
        if (splitType === "vertical") {
          splitPercentageValue = Math.round((x / containerRect.width) * 100);
        } else if (splitType === "horizontal") {
          splitPercentageValue = Math.round((y / containerRect.height) * 100);
        }

        setSplitPercentage(splitPercentageValue);
      }
    }
  };

  const onCanvasMouseUp = () => {
    setIsDragging(false);
    setDragStart(null);
  };

  const splitPDF = async () => {
    console.log("Splitting PDF...");

    const formData = new FormData();
    pdfFile.forEach((file) => formData.append("pdfFiles", file));
    formData.append("orientation", splitType);
    formData.append("splitPercentage", splitPercentage);
    formData.append("side", splitDirection);

    try {
      console.log("Sending request to server...");
      const response = await axios.post(
        "https://test.workrspot.com/split-pdf",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );

      console.log("Server response:", response);

      if (pdfFile.length === 1) {
        console.log("Downloading single file...");
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          pdfFile[0].name.replace(".pdf", `_split.pdf`)
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.log("Downloading multiple files as zip...");
        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "split_files.zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error splitting PDF:", error);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "application/pdf",
    onDrop: (acceptedFiles) => {
      setPdfFile(acceptedFiles);
      setSplitLineVisible(true);
    },
  });

  //styles of the handle and split line
  const handleStyle = {
    position: "absolute",
    zIndex: 800,
    width: "20px",
    height: "20px",
    backgroundColor: "black",
    opacity: "0.9",
    borderRadius: "50%",
    marginLeft: `${splitType === "vertical" ? "80px" : "0px"}`,
    marginTop: `${splitType === "horizontal" ? "76px" : "0px"}`,
    cursor: splitType === "vertical" ? "ew-resize" : "ns-resize",
    left: `${splitType === "vertical" ? splitPercentage - 10 : 0}%`,
    top: `${splitType === "horizontal" ? splitPercentage - 10 : 0}%`,
    transform: "translate(-50%, -50%)",
  };

  const splitLineStyle = {
    position: "absolute",
    zIndex: 600,
    backgroundColor: "rgba(0, 0, 255, 0.1)", // Semi-transparent black
    cursor: splitType === "vertical" ? "ew-resize" : "ns-resize",
    width: splitType === "vertical" ? `${splitPercentage}%` : "100%",
    height: splitType === "horizontal" ? `${splitPercentage}%` : "100%",
    left: 0,
    top: 0,
    borderStyle: "dashed",
    opacity: "0.5",
  };

  return (
    <>
      {!pdfFile && (
        <div
          {...getRootProps()}
          className="container text-center mt-5"
          style={{
            border: "2px dashed black",
            cursor: "pointer",
            position: "relative",
          }}
        >
          <div className="row justify-content-center">
            <div className="col-8">
              <p className="text-center pt-5 pb-3"></p>
              <div className="dropzone text-center p-3">
                <button className="btn btn-primary">
                  <input {...getInputProps()} accept=".pdf" />
                  <p className="h4 mb-0 fw-bold py-3 text-white px-4 stretched-link">
                    Select PDF Files
                  </p>
                </button>
                <p className="pt-4 pb-5">(Drop PDF here)</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {pdfFile && (
        <div className="container mt-5">
          <div className="row">
            <div className="col-8">
              <div
                ref={containerRef}
                style={{
                  position: "relative",
                  width: "100%",
                  height: "773px",
                  overflow: "hidden",
                  // border: '1px solid #ccc',
                }}
                onMouseDown={onCanvasMouseDown}
                onMouseMove={onCanvasMouseMove}
                onMouseUp={onCanvasMouseUp}
              >
                {splitLineVisible && (
                  <>
                    <div style={splitLineStyle} />
                    {/* Draggable handle */}
                    <div
                      ref={handleRef}
                      style={handleStyle}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        setIsDragging(true);
                      }}
                    />
                  </>
                )}
                <Document
                  file={pdfFile[0]}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      width={
                        containerRef.current
                          ? containerRef.current.offsetWidth
                          : undefined
                      }
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  ))}
                </Document>
              </div>
            </div>
            <div className="col-4">
              <div className="mb-3">
                <label>Split Percentage:</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  value={splitPercentage}
                  onChange={(e) => setSplitPercentage(parseInt(e.target.value))}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <button
                  onClick={() => setSplitType("vertical")}
                  className="btn btn-primary me-2"
                >
                  Vertical Split
                </button>
                <button
                  onClick={() => setSplitType("horizontal")}
                  className="btn btn-primary"
                >
                  Horizontal Split
                </button>
              </div>
              <p className="mb-3">Drag the line to split the PDF:</p>
              <button
                onClick={splitPDF}
                className="btn btn-success"
                disabled={!pdfFile}
              >
                Split PDF
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default App;
